<template>
  <div class="MobileLogin">
    <Form
      :model="form"
      :rules="rules"
      v-model="regular"
    >
      <Input
        class="temr"
        label=""
        v-model="form.phone"
        :reg="rules.phone"
        :maxlength="13"
        :readonly="isLock"
        :separate="true"
        labelWidth="90px"
        placeholder="请输入手机号"
      />
      <message-code
        class="temr"
        label=""
        :reg="rules.captcha"
        placeholder="请输入验证码"
        v-model="form.captcha"
        v-bind="$listeners"
        @getSendPicCode="getSendPicCode"
        :argementFlag="argementFlag"
        :params="{
          phone: form.phone.replace(/\s+/g, ''),
          type: 3,
          method: 'getSms',
        }"
      ></message-code>
    </Form>
    <div class="Contract">
      <Contract
        text="未注册过的手机号将自动创建平台账号，且代表您已阅读并同意"
        :list="contractList"
        :argementFlag="argementFlag"
        :changeArgementFlag="changeArgementFlag"
        :defaultCheck="false"
        v-model="isAgree"
      />
    </div>
    <Button
      :loading="loading"
      loadingText="提交中..."
      type="danger"
      text="登录"
      :disabled="!regular"
      class="nextStep"
      :click="nextStep"
    />
  </div>
</template>

<script>
import Form from '@/components/Form.vue';
import Input from '@/components/Input.vue';
import { rules } from '@/utils';
import Button from '@/components/Button.vue';
import JSencrypt from '@/utils/rsa/jsencrypt';
import { Toast } from 'vant';
import Contract from './Contract.vue';
import MessageCode from './MessageCode.vue';

export default {
  name: 'MobileLogin',
  data() {
    return {
      form: {
        phone: '',
        captcha: '',
      },
      rules: {
        phone: rules.phone,
        captcha: rules.captcha,
      },
      isAgree: false,
      loading: false,
      regular: false,
      contractList: [
        {
          text: '用户服务协议',
          value: 'REGISTERAGREEMENT',
        },
        {
          text: '授权承诺书',
          value: 'bw_sq',
        },
        {
          text: '隐私政策',
          value: 'bw_ys',
        },
      ],
      argementFlag: false,
    };
  },
  props: ['mobile', 'isLock', 'getSendPicCode'],
  watch: {
    mobile: {
      handler(val) {
        console.log('我是监听的watch======mobile的值======', val);
        this.form = {
          ...this.form,
          phone: val,
        };
      },
      immediate: true,
    },
    'form.phone': {
      handler(val) {
        console.log('我是监听的watch======form.phone======', val);
        if (!val) return;
        this.$emit('getCachePhone', val.replace(/\s+/g, ''));
      },
    },
  },
  components: {
    Form,
    Input,
    Button,
    MessageCode,
    Contract,
  },
  methods: {
    nextStep() {
      console.log(`2343243243========,${this.argementFlag}`);
      if (!this.argementFlag) {
        Toast({
          message: '请先勾选同意相关协议',
          forbidClick: true, // 背景不可点击
        });
        return false;
      }

      const obj = JSON.parse(JSON.stringify(this.form));
      obj.phone = obj.phone.replace(/\s+/g, '');
      const encrypt = new JSencrypt();
      encrypt.setPublicKey(
        'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAJw/nF+v0qHYsf5TxSVN97iHMydfBEsfCAVSSBSvxXtcWOOZN3fpeNoH9P5KPpxF9+BVrAynIV4dIFgRhE58aRECAwEAAQ==',
      );
      obj.unencryptedPhone = obj.phone;
      obj.phone = encrypt.encrypt(obj.phone);
      obj.captcha = encrypt.encrypt(obj.captcha);
      obj.foreignOrderId = this.$route.query.foreignOrderId;
      this.$emit('login', obj);
    },
    changeArgementFlag(flag = false) {
      this.argementFlag = flag;
    },
  },
  mounted() {
    console.log(JSencrypt);
  },
};
</script>
<style scoped>
.nextStep {
  margin-top: 70px;
}
.temr::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  margin: 0 16px;
  box-sizing: border-box;

  border-bottom: 1px solid #dddee1;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: " ";
  pointer-events: none;
}
.MobileLogin >>> .van-field__label {
  width: 0px;
}
.MobileLogin >>> .Input {
  padding: 16px;
}
.MobileLogin >>> .Input input {
  font-size: 15px !important;
}
.MobileLogin >>> .van-field__control {
  font-size: 15px !important;
}
.MobileLogin >>> .van-cell {
  padding: 14px 16px !important;
}
.MobileLogin >>> #buttonStyle {
  font-size: 15px !important;
}
.Contract {
  margin-top: 12px;
}
</style>
